import { Spinner } from '@citizen-walk/shared-ui';
import { Link } from 'react-router-dom';
import type { DistrictState } from './DistrictContext';

/**
 * 地区が未解決 (loading / error / Provider 外) のときに、地区依存ページ
 * (AppHome / MapPage / AnalysisPage / MapDownloadPage) が render する全画面プレースホルダ。
 *
 * 地区フォールバック根絶 (2026-06-08): 以前はこれらのページが地区未解決でも
 * `PHASE2_FALLBACK_DISTRICT` (id `'phase2-default'`) を使って描画を続けていたため、
 * 誤地区 (`districts/phase2-default/*`) への読み書きが発生していた。本コンポーネントで
 * 「解決中はスピナー / 失敗はエラー + 地区一覧への導線」を出し、地区が ready になるまで
 * 地区依存 UI を一切描画しない。
 */
export function DistrictPendingScreen({ state }: { state: DistrictState | null }) {
  if (state?.status === 'error') {
    return (
      <main className="flex flex-col items-center justify-center h-dvh bg-white px-6 text-center">
        <p className="text-base font-medium text-slate-900 mb-2">地区情報を取得できませんでした</p>
        <p className="text-sm text-slate-600 mb-6 max-w-sm">
          配布された QR コードまたは URL から、もう一度アクセスしてください。
        </p>
        <Link
          to="/"
          className="inline-block bg-primary-600 text-white text-sm font-medium py-2 px-4 rounded-md hover:bg-primary-700"
        >
          参加地区の一覧へ
        </Link>
      </main>
    );
  }
  return (
    <main className="flex items-center justify-center h-dvh bg-white">
      <Spinner label="地区情報を読み込み中…" />
    </main>
  );
}
